import Joi from 'joi';

import { PolicyTypeEnum } from '../../enums/policy-type.enum';

import { depositConfigSchema } from './deposit-config.schema';
import { driverEligibilityConfigSchema } from './driver-eligibility-config.schema';
import { fuelConfigSchema } from './fuel-config.schema';
import { lateReturnConfigSchema } from './late-return-config.schema';
import { mileageConfigSchema } from './mileage-config.schema';
import { minimumRentalConfigSchema } from './minimum-rental-config.schema';
import { rentalDurationConfigSchema } from './rental-duration-config.schema';
import { workingPeriodsConfigSchema } from './working-periods-config.schema';

const policyConfigSchema = () =>
	Joi.when('type', {
		is: PolicyTypeEnum.WORKING_PERIODS,
		then: workingPeriodsConfigSchema(),
		otherwise: Joi.when('type', {
			is: PolicyTypeEnum.FUEL,
			then: fuelConfigSchema(),
			otherwise: Joi.when('type', {
				is: PolicyTypeEnum.RENTAL_DURATION,
				then: rentalDurationConfigSchema(),
				otherwise: Joi.when('type', {
					is: PolicyTypeEnum.MINIMUM_RENTAL,
					then: minimumRentalConfigSchema(),
					otherwise: Joi.when('type', {
						is: PolicyTypeEnum.DRIVER_ELIGIBILITY,
						then: driverEligibilityConfigSchema(),
						otherwise: Joi.when('type', {
							is: PolicyTypeEnum.DEPOSIT,
							then: depositConfigSchema(),
							otherwise: Joi.when('type', {
								is: PolicyTypeEnum.LATE_RETURN,
								then: lateReturnConfigSchema(),
								otherwise: Joi.when('type', {
									is: PolicyTypeEnum.MILEAGE,
									then: mileageConfigSchema(),
									otherwise: Joi.forbidden(),
								}),
							}),
						}),
					}),
				}),
			}),
		}),
	});

/**
 * Schema for existing policy record validation.
 * Config is validated based on policy type.
 */
export const updatePolicySchema = () =>
	Joi.object({
		id: Joi.alternatives()
			.conditional(Joi.any().valid(null), {
				then: Joi.invalid(null).messages({
					'any.invalid': 'validations|policy-id|cannot-be-null',
				}),
				otherwise: Joi.number().required().messages({
					'any.required': 'validations|policy-id|required',
					'number.base': 'validations|policy-id|must-be-number',
				}),
			})
			.required()
			.messages({
				'any.required': 'validations|policy-id|required',
			}),

		type: Joi.alternatives()
			.conditional(Joi.any().valid(null), {
				then: Joi.invalid(null).messages({
					'any.invalid': 'validations|policy-type|cannot-be-null',
				}),
				otherwise: Joi.string()
					.valid(...Object.values(PolicyTypeEnum))
					.required()
					.messages({
						'any.required': 'validations|policy-type|required',
						'any.only': 'validations|policy-type|invalid-value',
					}),
			})
			.required()
			.messages({
				'any.required': 'validations|policy-type|required',
			}),

		name: Joi.string().max(256).allow(null, '').optional(),

		config: Joi.alternatives()
			.conditional(Joi.any().valid(null), {
				then: Joi.invalid(null).messages({
					'any.invalid': 'validations|policy-config|cannot-be-null',
				}),
				otherwise: policyConfigSchema(),
			})
			.required()
			.messages({
				'any.required': 'validations|policy-config|required',
			}),

		notes: Joi.string().max(1024).allow(null, '').optional(),
	}).unknown();
